import { Controller } from "@hotwired/stimulus"

// Opens the shared New-collection modal, optionally carrying the
// collectable being saved (from the Save-to menu).
export default class extends Controller {
  static values = {
    collectableSgid: String,
    collectableName: String,
  }

  declare readonly collectableSgidValue: string
  declare readonly collectableNameValue: string

  open() {
    this.dispatch("open", {
      prefix: "new-collection",
      detail: {
        collectableSgid: this.collectableSgidValue,
        collectableName: this.collectableNameValue,
      },
    })
  }
}
